// This was created to manipulate the DOM outside of the traditional React scope.
// The IDG document in this case renders using a static dangerouslySetInnerHTML string, so triggering
// this function attaches traditional JavaScript event listeners and queries to the static HTML to turn it
// back into a dynamic element.

export const staticIdgPrintJquery = () => {
  const printHeaderOnClick = (e: Event, isText: boolean) => {
    e.preventDefault();
    let target = e.target as HTMLElement;

    if (isText && e.target) {
      const newTarget = e.target as HTMLElement;
      target = newTarget.closest('.widget-print-header') as HTMLElement;
    }

    if (target.nextElementSibling) {
      const $sectionDetails = target.nextElementSibling;
      const $sectionDetailsDisplay = target.nextElementSibling.getAttribute(
        'id',
      );
      const $sectionDetailsText = target.nextElementSibling.firstElementChild;

      if (!$sectionDetailsDisplay && $sectionDetails) {
        if ($sectionDetailsText) {
          $sectionDetailsText.setAttribute('id', 'show');
        }
        $sectionDetails.setAttribute('id', 'show');
      }
      if ($sectionDetailsDisplay === 'hide' && $sectionDetails) {
        if ($sectionDetailsText) {
          $sectionDetailsText.setAttribute('id', 'show');
        }
        $sectionDetails.setAttribute('id', 'show');
      }
      if ($sectionDetailsDisplay === 'show' && $sectionDetails) {
        if ($sectionDetailsText) {
          $sectionDetailsText.setAttribute('id', 'hide');
        }
        $sectionDetails.setAttribute('id', 'hide');
      }
    }
  };

  const $widgetHeaders = document.querySelectorAll(
    '#print-manifest-content * .widget-print-header',
  );
  const $widgetPrintH5s = document.querySelectorAll(
    '#print-manifest-content * .widget-print-h5',
  );
  $widgetPrintH5s.forEach((header) =>
    header.addEventListener('click', (e) => printHeaderOnClick(e, true)),
  );
  $widgetHeaders.forEach((header) => {
    header.addEventListener('click', (e) => printHeaderOnClick(e, false));
  });
};
